<template>
    <div class="xl:pl-[15%] text-white transition-all duration-1000 w-screen max-w-full easy-in-out">
        <slot />
    </div>
</template>